/**
 * @generated SignedSource<<11b231cd6c02553d35cade7f32b48a2a>>
 * @relayHash 2d27dcc1d1eac2731f01ec3e79c7f7d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd

import type { ConcreteRequest } from 'relay-runtime';
export type useAutomatedMeetingNotesPagePropertiesQuery$variables = {
  pageAri: string;
};
export type useAutomatedMeetingNotesPagePropertiesQuery$data = {
  readonly page: {
    readonly id: string | null | undefined;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly subType: string | null | undefined;
  } | null | undefined;
};
export type useAutomatedMeetingNotesPagePropertiesQuery = {
  response: useAutomatedMeetingNotesPagePropertiesQuery$data;
  variables: useAutomatedMeetingNotesPagePropertiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageAri"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "pageAri"
      }
    ],
    "concreteType": "Page",
    "kind": "LinkedField",
    "name": "page",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Literal",
            "name": "keys",
            "value": [
              "isAutomatedMeetingNotes",
              "meetingRecurrenceAri"
            ]
          }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
          {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ],
        "storageKey": "properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"])"
      },
      {
        "kind": "ScalarField",
        "name": "subType"
      },
      {
        "kind": "ScalarField",
        "name": "id"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAutomatedMeetingNotesPagePropertiesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAutomatedMeetingNotesPagePropertiesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2d27dcc1d1eac2731f01ec3e79c7f7d9",
    "id": "bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd",
    "metadata": {},
    "name": "useAutomatedMeetingNotesPagePropertiesQuery",
    "operationKind": "query",
    "text": "query useAutomatedMeetingNotesPagePropertiesQuery($pageAri:ID!){page(id:$pageAri){properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"]){nodes{key,value}},subType,id}}"
  }
};
})();

(node as any).hash = "a7e1d622b5e3dfb0202b4f6045de22bd";

export default node;
